import { render } from "./PublicRaiseOrderBookTable.vue?vue&type=template&id=1087458a&scoped=true"
import script from "./PublicRaiseOrderBookTable.vue?vue&type=script&lang=js"
export * from "./PublicRaiseOrderBookTable.vue?vue&type=script&lang=js"

import "./PublicRaiseOrderBookTable.vue?vue&type=style&index=0&id=1087458a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1087458a"]])

export default __exports__